import { Card, Container, Row } from "react-bootstrap"
import { RevenueByDay } from "./charts/RevenueByDay"
import { RevenueByNetworkBar } from "./charts/RevenueByNetworkBar"
import RevenueHud from "./charts/RevenueHud"
import { RevenueByJourneyStep } from "./charts/RevenueByJourneyStep"

const Revenue = ({ data }: { data: any }) => {
  // The backend returns `revenue` as an empty array (not an object) when the
  // deal's billing model has no step-based revenue — fixed-fee / subscription /
  // media-spend. Revenue lives on the contract there, so the step/conversion
  // charts don't apply.
  const revenueNotApplicable = Array.isArray(data?.revenue)

  return (
    <>
      <Container
        className="d-flex flex-column gap-3 mb-5"
        style={{ minHeight: 364 }}
      >
        {revenueNotApplicable ? (
          <Row className="flex-grow-1">
            <Card className="custom-card border border-2 mb-0">
              <Card.Body className="text-center text-muted py-5">
                <i className="bi bi-receipt-cutoff fs-1 d-block mb-2" />
                <h6 className="fw-semibold mb-1">Revenue reporting not applicable</h6>
                <p className="mb-0 fs-12">
                  This deal bills on a fixed-fee, subscription, or media-spend
                  model, so revenue isn&apos;t derived from journey steps —
                  it&apos;s the fixed fee on the contract.
                </p>
              </Card.Body>
            </Card>
          </Row>
        ) : (
          <>
            <Row className="">
              <div className="d-flex ps-0 gap-2">
                <RevenueHud data={data} />
              </div>
            </Row>

            <Row className="flex-grow-1">
              {/* Revenue By Network (horizontal bar) */}
              <Card className="custom-card overflow-hidden mb-0 border border-2">
                <Card.Header className="justify-content-between">
                  <Card.Title>Revenue By Network</Card.Title>
                </Card.Header>
                <Card.Body>
                  <RevenueByNetworkBar series={data["revenue-by-network"]} />
                </Card.Body>
              </Card>
            </Row>

            <Row className="flex-grow-1">
              <Card className="custom-card border border-2 mb-0">
                <Card.Header>
                  <Card.Title>Revenue by Journey Step</Card.Title>
                </Card.Header>
                <Card.Body>
                  <RevenueByJourneyStep data={data} />
                </Card.Body>
              </Card>
            </Row>

            <Row className="flex-grow-1">
              <Card className="custom-card overflow-hidden mb-0 border border-2">
                <div className="card-header justify-content-between">
                  <Card.Title>Revenue by Day</Card.Title>
                </div>
                <Card.Body className="p-0">
                  <div className="px-3 mt-sm-0 mt-3">
                    <RevenueByDay series={data["revenue-by-day"]} />
                  </div>
                </Card.Body>
              </Card>
            </Row>
          </>
        )}
      </Container>
    </>
  )
}

export default Revenue
